export default __webpack_public_path__ + "static/media/Slide7.06aa2b4a.jpeg";